import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { findPageTitle } from '@/components/Menu/utils';
import { SIDEBAR_MENU_ITEMS, USER_MENU_ITEMS } from '@/constants';
export function useCurrentPageTitle() {
  const $ = _c(4);
  const pathname = usePathname();
  const t0 = pathname as string;
  let t1;
  if ($[0] !== t0) {
    t1 = findPageTitle(SIDEBAR_MENU_ITEMS, t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sidebarMenuTitle = t1;
  const t2 = pathname as string;
  let t3;
  if ($[2] !== t2) {
    t3 = findPageTitle(USER_MENU_ITEMS, t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const userMenuTitle = t3;
  return sidebarMenuTitle ?? userMenuTitle ?? "Unknown Page";
}